import { GetAllServicesForCompanyResponseType } from '@commenda/types/src/company/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

function useActiveServices(companyId: number) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: GetAllServicesForCompanyResponseType;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? `company/${companyId}/bff/services` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}

export { useActiveServices };
